import "./app.css";
import * as Sentry from "@sentry/react";
import { Route, Routes } from "react-router";
import { ProtectedRoute } from "./components/routing/protected-route";
import { PublicRoute } from "./components/routing/public-route";
import { RoleGuard } from "./components/routing/role-guard";
import { SharedComponents } from "./components/test/test-shared-components";
import { ErrorFallback } from "./error-fallback";
import { roles, routes } from "./lib/constants";
import { BrandSettingsPage } from "./pages/administration/brand-setting-page/brand-settings-page";
import { ListsPage } from "./pages/administration/lists/lists-page";
import { PermissionsPage } from "./pages/administration/permissions/permissions-page";
import { WorkflowsPage } from "./pages/administration/workflows-page/workflows-page";
import { CallbackPage } from "./pages/callback-page";
import { TasksPage } from "./pages/dashboard/task/tasks-page";
import { TaskManagerPage } from "./pages/dashboard/task-manager/task-manager-page";
import { LoginPage } from "./pages/login/login-page";
import { NotFoundPage } from "./pages/not-found-page";

export const App = () => {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <Routes>
        <Route element={<PublicRoute />}>
          <Route path={routes.login} element={<LoginPage />} />
        </Route>
        <Route element={<ProtectedRoute />}>
          <Route path={routes.dashboard.taskManager} element={<TaskManagerPage />} />
          <Route path={routes.dashboard.tasks} element={<TasksPage />} />
          <Route element={<RoleGuard allowedRoles={[roles.admin]} />}>
            <Route path={routes.administration.brandSettings} element={<BrandSettingsPage />} />
            <Route path={routes.administration.lists} element={<ListsPage />} />
            <Route path={routes.administration.permissions} element={<PermissionsPage />} />
            <Route path={routes.administration.workflows} element={<WorkflowsPage />} />
          </Route>
        </Route>
        <Route path="/test" element={<SharedComponents />} />
        <Route path={routes.callback} element={<CallbackPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Sentry.ErrorBoundary>
  );
};
